import { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import useEmailConfig from '../../hooks/email/useEmailConfig';
import EmailConfigurationForm from '../../components/email/EmailConfigurationForm';

const EmailConfigPage = () => {
  const {
    form,
    testEmail,
    error,
    updateField,
    updateTestEmail,
    loadEmailConfig,
    saveEmailConfig,
    sendTestEmail,
  } = useEmailConfig();

  useEffect(() => {
    loadEmailConfig();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const parsedValue = name === 'smtpPort' ? Number(value) || null : value;
    updateField(name as keyof typeof form, parsedValue as never);
  };

  const handleToggleField = (
    field: 'authEnabled' | 'tlsEnabled' | 'active'
  ) => {
    updateField(field, !form[field]);
  };

  return (
    <DefaultLayout>
      <Breadcrumb pageName="Configuración de Correo" />
      <SectionWrapper>
        <EmailConfigurationForm
          form={form}
          testEmail={testEmail}
          errors={error ? { general: error } : {}}
          onChange={handleChange}
          onToggleField={handleToggleField}
          onTestEmailChange={updateTestEmail}
          onSave={() => saveEmailConfig(form)}
          onSendTest={() => sendTestEmail(testEmail)}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default EmailConfigPage;
